import { useColorModeValue } from '@chakra-ui/react';

export const useQuoteMarketplaceTheme = () => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const textSecondary = useColorModeValue('gray.600', 'gray.400');
  const bgCardAlt = useColorModeValue('white', 'navy.700');
  const bgSubtle = useColorModeValue('gray.50', 'navy.800');
  const bgHoverAlt = useColorModeValue('gray.50', 'whiteAlpha.50');
  const bgMuted = useColorModeValue('gray.100', 'gray.700');
  const sectionHeaderBg = useColorModeValue('blue.50', 'blue.900');
  const sectionHeaderColor = useColorModeValue('blue.700', 'blue.200');
  const selectedHeaderBg = useColorModeValue('yellow.100', 'yellow.900');
  const selectedBorderColor = useColorModeValue('yellow.500', 'yellow.400');
  const selectedCellBg = useColorModeValue(
    'yellow.50',
    'rgba(236, 201, 75, 0.15)',
  );

  return {
    // Borders
    borderColor,
    borderColorStrong: useColorModeValue('gray.200', 'gray.600'),

    // Text colors
    textPrimary: useColorModeValue('secondaryGray.900', 'white'),
    textSecondary,
    textMuted: useColorModeValue('gray.500', 'gray.400'),

    // Backgrounds
    bgCard: useColorModeValue('white', 'navy.900'),
    bgCardAlt,
    bgSubtle,
    bgHover: useColorModeValue('gray.50', 'gray.700'),
    bgHoverAlt,
    bgMuted,

    // Status backgrounds
    bgInfo: useColorModeValue('blue.50', 'blue.900'),
    bgWarning: useColorModeValue('orange.50', 'orange.900'),
    bgSuccess: useColorModeValue('green.50', 'green.900'),
    bgError: useColorModeValue('red.50', 'red.900'),

    // Status borders
    borderWarning: useColorModeValue('orange.200', 'orange.700'),
    borderSuccess: useColorModeValue('green.200', 'green.900'),
    borderError: useColorModeValue('red.200', 'red.700'),

    // Section headers
    sectionHeaderBg,
    sectionHeaderColor,

    // Selection state
    selectedHeaderBg,
    selectedBorderColor,
    selectedCellBg,

    // Aliases for comparison table compatibility
    bgColor: bgCardAlt,
    headerBg: bgSubtle,
    labelColor: textSecondary,
    hoverBg: bgHoverAlt,
    requestedBg: bgMuted,
  };
};

export type QuoteMarketplaceTheme = ReturnType<typeof useQuoteMarketplaceTheme>;
